import { magicNumbers } from './magicNumbers';

// desc: چون ممکنه یکسری کوئری های اضافی مثل جست‌وجوی شما و فراموضوعی داشته باشیم باید اولین کوئری که غیر از این دو مورد باشه رو بدونیم چیه چون جاهای مختلف نیازه استفاده کنیم
export const getFirstQueryIndex = (queries) => {
  if (
    (queries?.length === 1 &&
      queries?.[0]?.id === magicNumbers.MEGA_SUBJECT_QUERY_ID) ||
    (queries?.length === 1 &&
      queries?.[0]?.id === magicNumbers.YOUR_SEARCH_QUERY_ID)
  ) {
    return 0;
  }

  if (
    queries?.[0]?.id !== magicNumbers.YOUR_SEARCH_QUERY_ID &&
    queries?.[0]?.id !== magicNumbers.MEGA_SUBJECT_QUERY_ID
  )
    return 0;

  if (
    queries?.[1]?.id !== magicNumbers.YOUR_SEARCH_QUERY_ID &&
    queries?.[1]?.id !== magicNumbers.MEGA_SUBJECT_QUERY_ID
  )
    return 1;

  return 2;
};
